import React, { ReactElement } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { css } from '@emotion/react';
import { ShareDataType } from '@type/web/product';

import useShare from '@lib/hook/share/useShare';

import Icon from '@components/common/Icon/Icon';

import { palette } from '../../../lib/styles/palette';

interface ShareModalType {
  onHidePopUp: () => void;
  shareData: ShareDataType;
  shareMessage?: string;
}

function ShareModal({
  shareMessage = '친구들에게 공유하기!',
  onHidePopUp,
  shareData,
}: ShareModalType): ReactElement {
  const {
    Toast,
    handleShareFacebook,
    handleShareKakao,
    handleCopyUrl,
    sharedUrl,
  } = useShare(shareData);

  return (
    <>
      <div css={wrapperStyle}>
        <h2 css={headingStyle}>{shareMessage}</h2>
        <ul css={shareUrlBoxStyle}>
          <li data-id="shareV1_facebook" onClick={handleShareFacebook}>
            <Icon icon="shareFacebook" aria-label="페이스북 공유하기" />
          </li>
          <li data-id="shareV1_kakao" onClick={handleShareKakao}>
            <Icon icon="shareKakao" aria-label="카카오톡 공유하기" />
          </li>
          <li data-id="shareV1_URL">
            <CopyToClipboard
              text={sharedUrl}
              onCopy={handleCopyUrl}
              data-id="shareV1_URL"
            >
              <Icon icon="shareUrl" aria-label="URL 복사하기" />
            </CopyToClipboard>
          </li>
        </ul>
      </div>
      <Icon
        icon="xClose"
        size={24}
        css={closeButtonStyle}
        onClick={onHidePopUp}
      />
      <Toast>복사 되었습니다</Toast>
    </>
  );
}

const wrapperStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const headingStyle = css`
  font-size: 16px;
  color: ${palette.white};
  margin-bottom: 20px;
`;

const shareUrlBoxStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;

  & li {
    cursor: pointer;
    margin-right: 20px;
  }
`;

const closeButtonStyle = css`
  position: absolute;
  background: transparent;
  cursor: pointer;
  top: 54px;
  right: 20px;

  & path {
    stroke: white;
  }
`;

export default ShareModal;
